import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageview } from '../lib/analytics';

// Invisible tracker: records pageviews on every route change + sets up click/duration listeners.
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + (location.search || ''));
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
